module.exports = __webpack_public_path__ + "img/profile.c6a91171.svg";